import React from 'react'
import Notification from "./Notification"

const index = () => <Notification/>

export default index